import { render, staticRenderFns } from "./CounsellorView.vue?vue&type=template&id=d43dacbe&"
import script from "./CounsellorView.vue?vue&type=script&lang=js&"
export * from "./CounsellorView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports